import 'moment/locale/es'

import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { es } from 'date-fns/locale'

export const DateFilters = ({ filters, setFilters, handleChangeDate }) => {
    return (
        <div className='d-flex mt-3'>
            {/* <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                <input type="radio" className="btn-check" name="btnradio" id="btnradio2" autoComplete="off"
                    checked={filters.time === 'year' && 'checked'}
                    onChange={() => setFilters({ ...filters, time: 'year' })}
                />
                <label className="btn btn-outline-light" htmlFor="btnradio2" style={{ color: filters.time === 'year' ? '#8E24AA' : '#595759' }}>
                    Vista mensual (<span style={{ textTransform: 'capitalize' }}>Año</span>{' '}{moment(filters.dateFrom).format('YYYY')})
                </label>
            </div> */}
            <div className='p-text-date-year'>
                <LocalizationProvider locale={es} dateAdapter={AdapterDateFns}>
                    <DatePicker
                        views={['year']}
                        label="Año"
                        openTo="year"
                        name='dateFrom'
                        // minDate={new Date('2020-01-01')}
                        value={filters.dateFrom}
                        onChange={handleChangeDate}
                        renderInput={(params) => <TextField {...params} helperText={null} />}
                    />
                </LocalizationProvider>
            </div>
        </div>
    )

}